import { Link, useLocation } from "react-router";

import { trackEvent } from "@/lib/mixpanel";
import { FOOTER_LINKS } from "@/utils/constants";

export const Footer = () => {
  const pathname = useLocation().pathname;

  // Homepage has its own footer
  if (pathname === "/") return null;

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-30 w-full border-t border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-3 text-sm text-slate-700 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-2 font-semibold text-green-700">
          <span className="h-2 w-2 rounded-full bg-green-500" aria-hidden />
          Online
        </div>
        <div className="flex flex-wrap items-center gap-4">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="text-sm text-slate-700 underline-offset-4 hover:text-slate-900 hover:underline"
              onClick={() =>
                trackEvent("Footer Link Clicked", {
                  link_name: link.label,
                  from_page: pathname || "/",
                  to_page: link.href,
                })
              }
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};
